import { closestCorners, Collision, pointerWithin } from '@dnd-kit/core';
import { useMemo } from 'react';

const customCollisionDetectionAlgorithm = (args: any): Collision[] => {
  const pointerCollisions = pointerWithin(args);

  // check if there are any collisions with the pointer
  if (pointerCollisions.length > 0) {
    return pointerCollisions;
  }

  return closestCorners(args);
};
const useCollisionDetection = (): ((args: any) => Collision[]) => {
  return useMemo(() => customCollisionDetectionAlgorithm, []);
};

export default useCollisionDetection;
